export default __webpack_public_path__ + "static/media/billableActivity.0927f854.svg";